import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { DataFilter } from "../models/data-filter-model";

@Injectable({
  providedIn: "root",
})
export class GeneralDataService {
  public serviceURL = environment.serviceURL;
  dataFilter: DataFilter;

  constructor(private readonly http: HttpClient) {}

  getGeneralData(start, end, searchSupplier) {
    const body = {
      start: start,
      end: end,
      supplierName: searchSupplier,
    };
    const URL = `${this.serviceURL}/general/api/general/detail`;
    return this.http.post<any>(URL, body);
  }

  getCommonData() {
    const URL = `${this.serviceURL}/general/api/general/supplierValue`;
    return this.http.get(URL);
  }
}
